@if (filterForm) {
    <mat-drawer-container [hasBackdrop]="true">
        <mat-drawer #sidenav [mode]="'over'">
            <app-performance-filter-sidebar
                [filterForm]="filterForm"
                (closeButtonClicked)="sidenav.close()"
                [timeFrameList]="timeFrameList"
                [userList]="userList$ | async"
                [showGroupFilters]="groupsEnabled"
                [groupFilterOptions]="groupFilterOptions$ | async">
            </app-performance-filter-sidebar>
        </mat-drawer>
        <mat-drawer-content class="app-content listings">
            <app-performance-filter-topbar
                [filterForm]="filterForm"
                [currentFilters]="currentFilters"
                (filterButtonClicked)="sidenav.open()"
                [userList]="userList$ | async"
                [groupFilterOptions]="groupFilterOptions$ | async">
            </app-performance-filter-topbar>

            <div class="app-content px-0">
                @if (stats$ | async; as stats) {
                    <ng-container
                        [ngTemplateOutlet]="statsTemplate"
                        [ngTemplateOutletContext]="{
                            $implicit: stats,
                            sidenav: sidenav,
                            filters: statsFilters
                        }"></ng-container>
                } @else {
                    <app-loading-indicator></app-loading-indicator>
                }
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
}
